import { FormConfig, FormFieldType } from "../../../components/form/formTypes";

const topicPartFormConfig: FormConfig[] = [
  {
    name: "title",
    label: "topicPart.field.title",
    placeholder: "topicPart.field.titlePlaceholder",
    type: FormFieldType.Text,
  },
  {
    name: "description",
    label: "topicPart.field.description",
    placeholder: "topicPart.field.descriptionPlaceholder",
    type: FormFieldType.Textarea,
  },
  {
    name: "timing",
    label: "topicPart.field.duration",
    placeholder: "topicPart.field.durationPlaceholder",
    type: FormFieldType.Number,
    settings: { hideForViewer: true },
  },
  {
    name: "videoLink",
    label: "topicPart.field.videoLink",
    placeholder: "topicPart.field.videoLinkPlaceholder",
    type: FormFieldType.Text,
    settings: { hideForViewer: true },
  },
  {
    name: "videoFile",
    label: "topicPart.field.videoFile",
    type: FormFieldType.Media,
    settings: { hideForViewer: true, mediaType: "video" },
  },
  {
    name: "audioFile",
    label: "topicPart.field.audioFile",
    type: FormFieldType.Media,
    settings: { hideForViewer: true, mediaType: "audio" },
  },
  {
    name: "contentText",
    label: "topicPart.field.contentText",
    placeholder: "topicPart.field.contentTextPlaceholder",
    type: FormFieldType.RichText,
  },
  {
    name: "additionalText",
    label: "topicPart.field.additionalText",
    placeholder: "topicPart.field.additionalTextPlaceholder",
    type: FormFieldType.RichText,
  },
  {
    name: "answerTogether",
    label: "topicPart.field.answerTogether",
    type: FormFieldType.Switch,
    settings: { hideForViewer: true },
  },
  {
    name: "isSynthesisPart",
    label: "topicPart.field.isSynthesisPart",
    type: FormFieldType.Switch,
    settings: { hideForViewer: true },
  },
  {
    name: "comments",
    label: "topicPart.field.comments",
    placeholder: "topicPart.field.commentsPlaceholder",
    type: FormFieldType.Textarea,
  },
];

export default topicPartFormConfig;
